export default __webpack_public_path__ + "static/media/bindings_of_the_forsaken.d2f8d428.jpg";